import { render, staticRenderFns } from "./DarlingtonCity.vue?vue&type=template&id=22ac81c8&scoped=true&"
import script from "./DarlingtonCity.vue?vue&type=script&lang=js&"
export * from "./DarlingtonCity.vue?vue&type=script&lang=js&"
import style0 from "./DarlingtonCity.vue?vue&type=style&index=0&id=22ac81c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac81c8",
  null
  
)

export default component.exports